<script>
import imageUrlBuilder from '@sanity/image-url'
import client from '@sanityConfig'
import { mapState } from 'vuex'
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import { colorMixin } from '../../mixins/colorMixin'
import { fontMixin } from '../../mixins/fontMixin'
import { Carousel, Slide } from 'vue-carousel'
import { dateTimeFormatters } from '@src/utils/date-formatters'
const { formatDate } = dateTimeFormatters()

const blocksToHtml = require('@sanity/block-content-to-html')
const builder = imageUrlBuilder(client)

export default {
  components: {
    Carousel,
    Slide
  },
  props: {
    component: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  mixins: [breakpointsMixin, colorMixin, fontMixin],
  data () {
    return {}
  },
  created () {
    this.$_addFont(this.componentFont)
    console.log(this.component)
  },
  computed: {
    ...mapState(['settings']),
    componentFont () {
      return (
        this.component && this.component.fontSetup && this.component.fontSetup.font &&
          this.component.fontSetup.font.fontFamily
      )
    }
  },
  methods: {
    convertWysiwyg (source) {
      return blocksToHtml({
        blocks: source
      })
    },
    testimonialImage (testimonial) {
      return (
        testimonial &&
        testimonial.photo &&
          builder.image(testimonial.photo)
      )
    },
    testimonialDate (testimonial) {
      return (
        (testimonial &&
        testimonial.date &&
        formatDate(testimonial.date, 'LL')) ||
          ''
      )
    }
  }
}
</script>

<template>
  <section
    class="container--testimonials"
    :style="{
      '--backgroundColor': $_rgba(component.backgroundColor, 1),
      '--primaryTextColor': $_rgba(settings.primaryColor, 1),
      '--textColor': $_rgba(component.textColor, 1),
      '--fontFamily': `'${componentFont && componentFont.family ? componentFont.family : 'Nunito Sans'}'`,
    }"
  >
      <div class="carousel-wrapper">
        <carousel
          class="carousel"
          :autoplay="true"
          :paginationEnabled="true"
          paginationColor="rgba(74, 82, 85, 0.4"
          :paginationActiveColor="$_rgba(settings.primaryColor, 1)"
          :scrollPerPage="true"
          :perPage="1"
          :perPageCustom="[[950, 1.5], [1250, 2]]"
          :loop="true"
          :centerMode="true"
        >
          <slide
            v-for="testimonial in component.testimonials"
            :key="testimonial.key">
            <div class="testimonial-wrapper">
              <img :src="testimonialImage(testimonial)" alt="testimonial Image" class="image desktop">
              <div class="image-wrapper mobile">
                <img :src="testimonialImage(testimonial)" alt="testimonial Image" class="image">
              </div>
              <div class="text-wrapper">
                <p
                  >{{ testimonialDate(testimonial) }}</p
                >
                <p class="header"
                  >{{ testimonial.headerText && testimonial.headerText ? testimonial.headerText : '' }}</p
                >
                <p >{{ testimonial.summary && testimonial.summary ? testimonial.summary : '' }}</p>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
  </section>
</template>

<style lang="scss" scoped>
@import '@design';

.container--testimonials {
  height: 640px;
  padding: 0;
  background-color: var(--backgroundColor);
  color: var(--textColor);

  .carousel {
    display: flex;
    align-content: center;
    justify-content: center;
    height: 640px;
    padding-left: 1rem;
    padding-right: 1rem;
    p {
      color: $color-text;
      font-family: var(--fontFamily);
      font-size: 20px;
      font-weight: 300;
      line-height: 2rem;
    }
    .testimonial-wrapper {
      display: flex;
      background: #fff;
      border-radius: 16px;
      margin: 0 12px;
      height: 300px;
      .text-wrapper {
        display: grid;
        gap: 10;
        padding: 24px 48px;
        font-family: var(--fontFamily);
        color: #525252;

        p {
          font-weight: 400;
          font-size: 14px;
          line-height: 16px;
        }
        .header {
          font-weight: 700;
          font-size: 24px;
          line-height: 28px;
        }
      }
      .image {
        width: 300px;
        height: 300px;
        border-top-left-radius: 16px;
        border-bottom-left-radius: 16px;
        object-fit: cover;
        object-position: top;
      }
      .mobile {
        display: none;
      }
      @media screen and (max-width: 700px) {
        flex-direction: column;
        height: max-content;
        padding: 16px;

        .image-wrapper {
          border-radius: 16px;
          width: 100%;
          height: 250px;
          overflow: hidden;
          .image {
            width: 100%;
          }
        }
        .text-wrapper {
          padding: 0;
          padding-top: 24px;
          .header {
            font-weight: 700;
            font-size: 18px;
            line-height: 21px;
          }
        }
        .desktop {
          display: none;
        }
        .mobile {
          display: revert;
        }
      }
    }
  }
}
</style>
